var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"blog-block blog-text-block"},[_c('div',{staticClass:"blog-text-block__content",domProps:{"innerHTML":_vm._s(_vm.data.text)}})])}
var staticRenderFns = []

export { render, staticRenderFns }